import React from 'react';
import {
    Grid,
    TextField,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { OrganizationUpdateDTO } from '../../types/Organization';

interface OrganizationDetailsPanelProps {
    expanded: boolean;
    onToggle: (event: React.SyntheticEvent, isExpanded: boolean) => void;
    organizationData: OrganizationUpdateDTO;
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const OrganizationDetailsPanel: React.FC<OrganizationDetailsPanelProps> = ({ expanded, onToggle, organizationData, handleInputChange }) => {
    return (
        <Accordion expanded={expanded} onChange={onToggle}>
            <AccordionSummary 
                expandIcon={<ExpandMoreIcon />}
                sx={{ 
                    backgroundColor: '#2B8EF820', // Light blue with transparency
                    '&.Mui-expanded': { minHeight: 48 },
                    '& .MuiAccordionSummary-content.Mui-expanded': {
                        margin: '12px 0'
                    }
                }}
            >
                <Typography sx={{ fontWeight: 'bold' }}>Details</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Organization Name"
                            name="name"
                            value={organizationData.name || ''}
                            onChange={handleInputChange}
                            inputProps={{ maxLength: 200 }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Street Address"
                            name="street_address"
                            value={organizationData.street_address || ''}
                            onChange={handleInputChange}
                            inputProps={{ maxLength: 200 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            fullWidth
                            label="City"
                            name="city"
                            value={organizationData.city || ''}
                            onChange={handleInputChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            fullWidth
                            label="State"
                            name="state"
                            value={organizationData.state || ''}
                            onChange={handleInputChange}
                            inputProps={{ maxLength: 2 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            fullWidth
                            label="Zip Code"
                            name="zip_code"
                            value={organizationData.zip_code || ''}
                            onChange={handleInputChange}
                            inputProps={{ maxLength: 5 }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Phone Number"
                            name="phone"
                            value={organizationData.phone || ''}
                            onChange={handleInputChange}
                            inputProps={{ maxLength: 20 }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Website"
                            name="website"
                            value={organizationData.website || ''}
                            onChange={handleInputChange}
                            inputProps={{ maxLength: 200 }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            label="Mission Statement"
                            name="mission"
                            value={organizationData.mission || ''}
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            label="Vision Statement"
                            name="vision"
                            value={organizationData.vision || ''}
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default OrganizationDetailsPanel;
